// Relative to the workspace-agent's /host bind. Compatibility symlinks stay
// untouched; the file explorer intentionally refuses to open symlinks.
export const hostPaths = Object.freeze({
  home: "home/basesul",
  projects: "srv/base-sul-dados/projetos/vps",
  desktop: "srv/base-sul-dados/arquivo-codex/usuario/Desktop",
});

export function migrateHostPath(value: string): string {
  const userStorage = "srv/base-sul-dados/arquivo-codex/usuario";
  const migratedFolders: readonly [string, string][] = [
    ["Área de trabalho", "Desktop"], ["Desktop", "Desktop"], ["Downloads", "Downloads"],
    ["Documentos", "Documentos"], ["Documents", "Documents"], ["Imagens", "Imagens"],
    ["Músicas", "Musicas"], ["Vídeos", "Videos-pt"],
  ];
  const aliases: readonly [string, string][] = [
    ...["basesul", "nectar"].flatMap((user) => migratedFolders.map(([name, target]): [string, string] =>
      [`home/${user}/${name}`, `${userStorage}/${target}`])),
    ["home/nectar/projetos", hostPaths.projects],
    ["home/basesul/projetos", hostPaths.projects],
    ["home/nectar", hostPaths.home],
  ];
  for (const [legacy, current] of aliases) {
    if (value === legacy || value.startsWith(`${legacy}/`)) {
      return current + value.slice(legacy.length);
    }
  }
  return value;
}
